import _ from 'lodash';

import { mapActions, mapGetters, mapMutations } from 'vuex';
import {
  PRODUCTS_VIEW_TYPE,
  getProductPriceTitle,
  resolveHoverProductImage,
  resolveProductImage,
  routeToProduct,
  ecommerceAddToCartEvent
} from '@/helpers';
import { MEDIA } from '@/helpers/variables';

import IconHeart from '@/components/icons/IconHeart.vue';
import IconDelete from '@/components/icons/IconDelete.vue';
import TypeSelect from './components/TypeSelect/index.vue';

export default {
  name: 'ProductCard',
  components: {
    IconDelete,
    IconHeart,
    TypeSelect
  },
  props: {
    product: {
      type: Object,
      default: () => {}
    },
    hover: {
      type: Boolean,
      default: true
    },
    isProductDesc: {
      type: Boolean,
      default: false
    },
    viewType: {
      type: String,
      default: PRODUCTS_VIEW_TYPE.GRID
    },
    titleTag: {
      type: String,
      default: 'h3'
    }
  },

  data() {
    return {
      PRODUCTS_VIEW_TYPE,
      MEDIA,
      isProductPriceInBasket: false,
      selectedProductPrice: null,
      favoriteSelect: false,
      basketKey: 1,
      leftoverType: null
    };
  },
  created() {
    if (this.product.productPrices?.data.length) {
      let { data: productPrices } = this.product.productPrices;
      let sortedProductPrices = _.orderBy(productPrices, ['value'], ['asc']);
      let defaultPrice = sortedProductPrices[0];
      this.selectProductPrice(defaultPrice);
    }
  },
  watch: {
    selectedProductPrice: function () {
      this.$router.query = this.selectedProductPrice.value;
      this.selectProductPrice(this.selectedProductPrice);
    },
    basket: function () {
      this.basketKey += 1;
      this.checkProductInBasket();
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      favourites: 'favorites/whichList',
      basket: 'basket/basket',
      user: 'profile/user',
      showNotifyLoader: 'products/showNotifyLoader',
      appSize: 'app/size'
    }),
    isHasDuplicate() {
      return this.product.hasDuplicate;
    },
    isOutStock() {
      return this.leftoverType.displayType === 'out-stock';
    },
    isShowWithoutPrice() {
      return this.selectedProductPrice && this.selectedProductPrice.showWithoutPrice;
    },
    isCanBePurchased() {
      return !this.isOutStock && !this.isHasDuplicate && !this.isShowWithoutPrice;
    },
    isDiscontinued() {
      return this.product.discontinued;
    },
    isHasAnalogue() {
      return this.product.analogueProduct && this.product.analogueProduct.data;
    },
    isComingSoon() {
      return this.product.isComingSoon;
    }
  },

  methods: {
    getProductPriceTitle,
    ...mapMutations({
      addToBasket: `basket/ADD_ITEM_TO_BASKET`,
      changeLoginPopup: 'popups/CHANGE_LOGIN_POPUP',
      changeFastBuyPopup: `popups/CHANGE_FAST_BUY_POPUP`,
      modalOpen: 'app/MODAL_OPEN'
    }),
    ...mapActions({
      addToFavorite: 'favorites/ADD_PRODUCT_TO_FAVOURITES',
      removeFromFavorite: 'favorites/REMOVE_PRODUCT_IN_FAVORITE',
      getFavorites: 'favorites/GET_FAVORITES_LIST',
      showNotifyPopup: 'products/SHOW_POPUP_PRODUCT_WHEN_AVAILABLE'
    }),
    routeToProduct: routeToProduct,
    resolveProductImage: resolveProductImage,
    resolveHoverProductImage: resolveHoverProductImage,
    /**
     * @param {ProductPrice} productPrice
     */
    selectProductPrice(productPrice) {
      this.selectedProductPrice = productPrice;
      this.leftoverType = productPrice.leftoverType.data;
      this.checkProductInBasket();
    },
    openFastBuy() {
      this.changeFastBuyPopup({
        show: true,
        product: {
          select_count: 1,
          select_type: this.selectedProductPrice,
          ...this.product
        }
      });
    },
    checkProductInBasket() {
      this.basketKey += 2;
      this.isProductPriceInBasket = _.some(this.basket, { select_type: { id: this.selectedProductPrice.id } });
    },

    onShowNotify() {
      const payload = {
        product_id: this.product.id,
        product_price_id: this.selectedProductPrice.id
      };

      this.showNotifyPopup(payload);
    },
    onChangeFavorite() {
      if (this.isAuthenticated) {
        const index = this.favourites.find((e) => e.productId === this.product.id);
        if (index) {
          this.removeFromFavorite(index.id).then(() => {
            this.getFavorites();
            this.favoriteSelect = false;
            this.$toasted.success(this.$t('toast.successRemoveFromFavorite'));
          });
        } else {
          this.addToFavorite({ product_id: this.product.id }).then(() => {
            this.favoriteSelect = true;
            this.$toasted.success(this.$t('toast.successAddToFavorites'));
            this.getFavorites();
          });
        }
      } else {
        this.changeLoginPopup(true);
      }
    },
    onAddBasket() {
      this.addToBasket({
        select_count: 1,
        product_price: this.selectedProductPrice,
        product: this.product,
        unauthorizedProductPriceId: this.product.unauthorizedProductPriceId
      });

      ecommerceAddToCartEvent({
        item_id: this.selectedProductPrice.id,
        item_name: this.product.title,
        item_brand: this.product.brandSeries?.title || 'Renew',
        item_category: this.product.brand?.title || '',
        item_variant: this.selectedProductPrice.title,
        price: this.selectedProductPrice.price,
        content_ids: this.product.unauthorizedProductPriceId
      });

      this.modalOpen('basketModal');
      this.checkProductInBasket();
      // this.$toasted.success(this.$t('toast.successAddBasket'));
    }
  }
};
